import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../../../core/services/user.service';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { Router } from '@angular/router';

interface User {
	name?: string;
	phone?: string;
	email?: string;
	gender?: string;
	role?: string;
}

@Component({
	selector: 'app-user-detail',
	templateUrl: './user-detail.component.html',
	styleUrls: ['./user-detail.component.scss'],
})
export class UserDetailComponent implements OnInit {
	user: User = {};
	userForm: FormGroup; // Create a FormGroup for your form
	loading = true;
	isEditing = false;

	constructor(
		public userService: UserService,
		public dialog: MatDialog,
		private fb: FormBuilder,
		private router: Router
	) {}

	ngOnInit(): void {
		// Initialize the form group and controls
		this.userForm = this.fb.group({
			name: [''], // You can add validation for the name if needed
			gender: [''], // Add validation if needed
			phone: [''], // You can add validation for the phone if needed
			email: [''], // You can add validation for the email if needed
		});
		this.getUser();
	}

	getUser(): void {
		this.userService.getSelfUserOp().subscribe((userAtt) => {
			userAtt.UserAttributes.forEach((att) => {
				if (att.Name === 'phone_number') {
					this.userForm.get('phone').setValue(att.Value);
					this.user.phone = att.Value;
				} else if (att.Name === 'name') {
					this.userForm.get('name').setValue(att.Value);
					this.user.name = att.Value;
				} else if (att.Name === 'gender') {
					this.userForm.get('gender').setValue(att.Value);
					this.user.gender = att.Value;
				} else if (att.Name === 'email') {
					this.userForm.get('email').setValue(att.Value);
					this.user.email = att.Value;
				} else if (att.Name === 'custom:role') {
					// You can add a role form control if needed and set its value here.
					this.user.role = att.Value;
				}
			});
			this.loading = false;
		});
	}

	getInitials(name: string): string {
		return name
			?.split(' ')
			.map((word) => word[0])
			.join('')
			.toUpperCase();
	}

	translateGender(gender: string): string {
		if (gender === 'WOMAN_CIS') {
			return 'Mulher Cis';
		} else if (gender === 'WOMAN_TRANS') {
			return 'Mulher Trans';
		} else if (gender === 'MAN_CIS') {
			return 'Homem Cis';
		} else if (gender === 'MAN_TRANS') {
			return 'Homem Trans';
		} else if (gender === 'NON_BINARY') {
			return 'Não Binário';
		} else {
			return '';
		}
	}
	editUser() {
		// Handle form submission here
		this.userService
			.updateUserB2g(this.userForm.value.gender, this.userForm.value.name)
			.subscribe((res: any) => {
				this.router
					.navigateByUrl('/home/user/detail')
					.then(() => window.location.reload());
			});
	}
	resetForm(form: NgForm) {
		form.reset(this.user);
	}

	goToChangePasswordPage() {
		this.router.navigate(['/home/user/change-password']);
	}
}
